import { Button } from '@mui/material';
import { onClickHandler } from './utilities/click_handler';
import colors from './colors';
import { iconName } from './iconNames';
import { IconUI } from './IconUI';

export type ButtonProps = {
  label: string
  onClick: () => void
  type?: 'primary' | 'secondary' | 'tertiary'
  width?: '100%'
  icon?: iconName
  disabled?: boolean
};

const styles: Record<NonNullable<ButtonProps['type']>, { color: string, variant: 'outlined' | 'contained', textColor: string, borderColor?: string }> = {
  primary: { color: colors.black, variant: 'contained', textColor: colors.white },
  secondary: { color: colors.white, variant: 'outlined', textColor: colors.black, borderColor: colors.grey },
  tertiary: { color: colors.greige, variant: 'contained', textColor: colors.black },
};

export const ButtonUI: React.FC<ButtonProps> = ({ label, onClick, type = 'primary', width, icon, disabled }) => {
  const style = styles[type];
  return (
    <Button
      onClick={onClickHandler(onClick)}
      variant={style.variant}
      startIcon={icon ? <IconUI name={icon} /> : undefined}
      style={{
        backgroundColor: style.color,
        color: style.textColor,
        boxShadow: 'none',
        width,
        borderColor: style.borderColor,
      }}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};
